import { Chip, CircularProgress } from "@mui/joy";
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import BlockIcon from '@mui/icons-material/Block';

export function ImportStatus({ recipeImport }) {
  if (recipeImport.status === 'pending') {
    return <Chip color="neutral" startDecorator={<TinyProgress />}>Pending</Chip>;
  }

  if (recipeImport.status === 'processing') {
    return <Chip  color="neutral" startDecorator={
      <TinyProgress value={100 * (recipeImport.processed + 1) / (recipeImport.total + 2)} color="primary" />
    }>
      Processing ({recipeImport.processed}/{recipeImport.total})
    </Chip>;
  }

  if (recipeImport.status === 'finished') {
    return Finished(recipeImport.errors > 0);
  }

  if (recipeImport.status === 'stopped') {
    return Stopped();
  }

  return '';
}

export function ImportItemStatus({ recipeImportItem }) {
  if (recipeImportItem.status === 'pending') {
    return <Chip color="neutral">Queued</Chip>;
  } 
  
  if (recipeImportItem.status === 'processing') {
    return <Chip  color="neutral" startDecorator={<TinyProgress color="primary" />}>Processing...</Chip>;
  }
  
  if (recipeImportItem.status === 'finished') {
    return Finished(recipeImportItem.error != null);
  }

  if (recipeImportItem.status === 'stopped') {
    return Stopped();
  }

  return '';
}

function Finished(hasErrors) {
  return <Chip color={hasErrors ? 'danger' : 'success'} startDecorator={hasErrors ? <ClearIcon/> : <DoneIcon/>}>Finished</Chip>;
}

function Stopped() {
  return <Chip color="warning" startDecorator={<BlockIcon/>}>Stopped</Chip>;
}

function TinyProgress({ value, color }) {
  return (
    <CircularProgress sx={{
      "--CircularProgress-size": "14px",
      "--CircularProgress-trackThickness": "2px",
      "--CircularProgress-progressThickness": "2px",
      ml: -0.25
    }} variant="plain" color={color} value={value} />
  );
}

